var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFreepikEmptyFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m512 190.587v289.543h-389.336c-6.521 0-11.796-5.285-11.796-11.796v-317.635c0-6.521 5.275-11.796 11.796-11.796h143.051c3.121 0 6.119 1.236 8.334 3.451l32.986 32.986c2.215 2.215 5.213 3.451 8.344 3.451h184.825c6.511.001 11.796 5.286 11.796 11.796z",
    fill: "#756f6f"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5b5555"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 324.065,
    cy: 207.547,
    r: 28.755
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.512 275.423c5.192 5.182 1.525 14.062-5.82 14.062h-90.8c-3.719 0-7.397-.186-11.023-.536v-138.25c0-6.521 5.275-11.796 11.796-11.796h102.513c4.78 12.372 7.407 25.827 7.407 39.889 0 30.566-12.393 58.236-32.42 78.273z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 190.587v289.543h-39.168v-289.543c0-6.511-5.275-11.796-11.796-11.796h39.167c6.512.001 11.797 5.286 11.797 11.796z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m391.699 332.217 120.301 147.916h-395.527c-3.55 0-6.91-1.599-9.15-4.353l-104.657-128.68c-6.268-7.707-.784-19.236 9.15-19.236h370.732c3.551 0 6.912 1.599 9.151 4.353z",
    fill: "#64b9fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 480.13h-50.726l-120.294-147.913c-2.246-2.751-5.604-4.358-9.148-4.358h50.716c3.554 0 6.912 1.607 9.148 4.358z",
    fill: "#31a7fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.426 445.438h-104.067c-3.217 0-6.249-1.503-8.198-4.063l-26.67-35.043c-2.581-3.391-.162-8.27 4.099-8.27h104.067c3.217 0 6.249 1.503 8.198 4.063l26.67 35.043c2.581 3.39.163 8.27-4.099 8.27z",
    fill: "#f8f3f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.426 445.435h-33.481c4.265 0 6.686-4.873 4.1-8.272l-26.671-35.036c-1.947-2.565-4.976-4.069-8.19-4.069h33.471c3.224 0 6.253 1.504 8.2 4.069l26.671 35.036c2.575 3.4.165 8.272-4.1 8.272z",
    fill: "#efe2dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 453.162h-47.272c-4.267 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h47.272c4.267 0 7.726 3.459 7.726 7.726s-3.459 7.726-7.726 7.726z",
    fill: "#f8f3f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.749 427.535h-20.065c-4.267 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h20.065c4.267 0 7.726 3.459 7.726 7.726.001 4.267-3.458 7.726-7.726 7.726z",
    fill: "#f8f3f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232.583 142.561c0-61.134-49.559-110.693-110.692-110.693-61.077 0-110.694 49.617-110.694 110.694.001 61.134 49.559 110.692 110.693 110.692h90.8c7.341 0 11.018-8.876 5.827-14.067l-18.355-18.355c20.032-20.03 32.421-47.704 32.421-78.271z",
    fill: "#31a7fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.512 239.191c5.192 5.192 1.525 14.062-5.82 14.062h-37.334c7.335 0 11.013-8.87 5.82-14.062l-11.382-11.388c-3.786-3.788-4.026-9.834-.574-13.929 16.238-19.26 26.028-44.148 26.028-71.314 0-54.764-39.775-100.247-92.016-109.117 5.055-.867 10.225-1.383 15.486-1.532 61.905-1.744 112.818 46.842 113.848 108.763.521 31.311-11.967 59.72-32.404 80.158z",
    fill: "#1c96f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.743 142.562 20.591-20.591c6.035-6.035 6.035-15.819 0-21.853-6.034-6.035-15.819-6.035-21.853 0l-20.591 20.591-20.59-20.592c-6.034-6.035-15.819-6.035-21.853 0-6.035 6.034-6.035 15.818 0 21.853l20.591 20.591-20.591 20.591c-6.035 6.035-6.035 15.819 0 21.853 3.017 3.018 6.972 4.526 10.927 4.526s7.909-1.509 10.927-4.526l20.591-20.591 20.591 20.591c3.018 3.018 6.971 4.526 10.927 4.526 3.954 0 7.909-1.509 10.927-4.526 6.035-6.034 6.035-15.818 0-21.853z",
    fill: "#f8f3f1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324.065,
    cy: 183.206,
    fill: "#bcea73",
    r: 28.755
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.818 183.203c0 15.887-12.878 28.765-28.752 28.765-5.322 0-10.315-1.446-14.586-3.982 11.288-2.602 19.698-12.707 19.698-24.783 0-12.063-8.397-22.181-19.685-24.783 4.271-2.523 9.251-3.968 14.573-3.968 15.875-.001 28.752 12.877 28.752 28.751z",
    fill: "#99d53b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.77,
    cy: 126.036,
    fill: "#bcea73",
    r: 22.692
  }), /*#__PURE__*/React.createElement("path", {
    d: "m447.46 126.034c0 12.537-10.162 22.699-22.689 22.699-4.2 0-8.14-1.141-11.511-3.142 8.908-2.053 15.544-10.028 15.544-19.557 0-9.52-6.626-17.504-15.534-19.558 3.37-1.991 7.3-3.132 11.5-3.132 12.528 0 22.69 10.163 22.69 22.69z",
    fill: "#99d53b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m372.92 84.56 4.18-4.18c3.018-3.018 3.018-7.909 0-10.927-3.017-3.017-7.909-3.017-10.927 0l-4.18 4.18-4.18-4.18c-3.017-3.018-7.909-3.018-10.927 0-3.018 3.017-3.018 7.909 0 10.927l4.18 4.18-4.18 4.18c-3.018 3.018-3.018 7.909 0 10.927 1.509 1.509 3.486 2.263 5.463 2.263s3.955-.755 5.463-2.263l4.18-4.18 4.18 4.18c1.509 1.509 3.486 2.263 5.463 2.263s3.955-.755 5.463-2.263c3.018-3.017 3.018-7.909 0-10.927z",
    fill: "#64b9fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.85 259.965c-3.017-3.017-7.909-3.017-10.927 0l-7.278 7.278-7.278-7.278c-3.017-3.017-7.909-3.017-10.927 0s-3.018 7.909 0 10.927l7.278 7.278-7.278 7.278c-3.018 3.017-3.018 7.909 0 10.927 1.509 1.509 3.486 2.263 5.463 2.263s3.955-.755 5.463-2.263l7.278-7.278 7.278 7.278c1.509 1.509 3.486 2.263 5.463 2.263s3.955-.755 5.463-2.263c3.018-3.017 3.018-7.909 0-10.927l-7.278-7.278 7.278-7.278c3.019-3.018 3.019-7.91.002-10.927z",
    fill: "#a8e7ef"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreepikEmptyFolder);
export default __webpack_public_path__ + "static/media/freepik-empty-folder.7e30717a5b91018bef3deb4419e8f5ba.svg";
export { ForwardRef as ReactComponent };